import React from 'react';

import { Collapse } from 'antd/es';

import { AreaAdditionalServiceWebsite } from '@app/objects/AreaService';

const carrotIcon = require('@app/images/carrot_dark.svg');

interface AreaServicesCommonInfoProps {
	additionalServices?: Array<AreaAdditionalServiceWebsite>;
	customReplacements?: Array<AreaAdditionalServiceWebsite>;
}

const AreaServicesCommonInfo: React.FC<AreaServicesCommonInfoProps> = ({ additionalServices, customReplacements }) => {
	const [combinedServices, setCombinedServices] = React.useState<Array<AreaAdditionalServiceWebsite>>();

	React.useEffect(() => {
		const services = additionalServices?.slice();

		if (customReplacements && customReplacements.length && services) {
			customReplacements.forEach((replacement) => {
				const index = services.findIndex((service) => service.name?.toUpperCase() === replacement.name?.toUpperCase());

				if (index >= 0) {
					services[index] = { name: services[index].name, description: replacement.description };
				}
			});
		}

		setCombinedServices(services);
	}, [additionalServices, customReplacements]);

	return (
		<div className="area-common-info">
			<section className="area__section">
				<Collapse
					className="area-services-collapse"
					bordered={false}
					defaultActiveKey={['0', '1', '2']}
					expandIcon={() => <img className="carrot-icon" src={carrotIcon} alt="" />}
					expandIconPosition="end"
					items={combinedServices?.map((question, index: number) => {
						return {
							key: index,
							label: question.name,
							children: <div dangerouslySetInnerHTML={{ __html: question.description || '' }} />,
						};
					})}
				/>
			</section>
		</div>
	);
};

export default AreaServicesCommonInfo;
